// @ts-nocheck
import { apiWithGetHeader } from "./api";
import { API_STATUS } from "./constant";
import { BACKEND_API_BASE_URL } from "../utilities/constant";
import { getUserAccessToken } from "../utilities/setting";
import { checkAuthSession } from "../views/dashboard/auth/auth-utils";
import { toast } from "sonner";
import { friendlyApiError } from "../utilities/apiErrorMessage";

export const getApiCall = async (url, payload, is_token_required = true) => {

  if (is_token_required) {
    const sessionValid = await checkAuthSession();
    if (!sessionValid) {
      return Promise.reject("Session Expired");
    }
  }
    const accessToken = getUserAccessToken();

    const response = await apiWithGetHeader(BACKEND_API_BASE_URL, payload, accessToken)
    .get(url, { timeout: 30000 })
    .catch(function (error) {
        if(error.response == undefined){
            var errorMsg = 'A network error occurred. This could be a CORS issue or a dropped internet connection.';
        }else{
            // const dataMsg = error.response.data.message ? String(error.response.data.message) : '';
            // const explanationMsg = error.response.data.error.explanation ? String(error.response.data.error.explanation) : '';
            // var errorMsg = dataMsg

            const dataMsg = error?.response?.data?.message ? String(error?.response?.data?.message) : '';
            const explanationMsg = error?.response?.data?.error?.explanation ? String(error?.response?.data?.error?.explanation) : '';
            var errorMsg = '';
            if (dataMsg && explanationMsg) {
              if (dataMsg === explanationMsg) {
                errorMsg = dataMsg;
              } else {
                errorMsg = `${dataMsg} ${explanationMsg}`;
              }
            } else {
              errorMsg = dataMsg || explanationMsg || 'Something went wrong';
            }
            if (errorMsg) {
              toast.error(friendlyApiError(errorMsg) || 'Something went wrong');
            }
        }
        return Promise.reject(errorMsg);
    });

    if (response.status == API_STATUS.SUCCESS || response.status == API_STATUS.CREATED || response.status == API_STATUS.ACCEPED) {
        return response.data.data;
    } else {
        return Promise.reject(response);
    }

};